import React, { useEffect, useState, useRef, useContext } from "react";
import { BASE_URL } from "../../../../../../BaseUrl";
import Moment from "react-moment";
import { getSystemSettings } from "../../../../../../functions/Functions";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { SettingsContext } from "../../../../../../contexts/Settings";

const parseData = (data) => {
  return data;
};

function formatKey(str) {
  return str.replace(/_/g, " ")
}

const OrderCardsWidget = ({ data, detail, heading, size, handleReq, date }) => {
  let { generalSettings } = useContext(SettingsContext);
  const [cards, setCards] = useState([]);
  const componentRef = useRef(null);

  useEffect(() => {
    handleReq();
  }, []);

  const handleReportDownload = async () => {
    const res = await handleReq("D");
    setTimeout(() => {
      if (res) {
        componentRef.current.handleDownload();
      }
    }, 10);
  };

  useEffect(() => {
    data && setCards(parseData(data));
  }, [data]);

  return (
    <>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Order Tracking Detail"
        sheet="sheet 1"
        buttonText="Download Report"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div className="fk-print">
          {detail !== null && detail && (
            <>
              <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                  <table
                    className="table table-bordered table-hover min-table-height mt-3"
                    id="table-to-xls"
                  >
                    <thead className="align-middle">
                      <tr style={{ border: "0px" }}>
                        <th colspan="8" style={{ border: "0px" }}>
                          <div className="row">
                            <div className="col-12">
                              <h3 className="text-center mb-0">
                                {getSystemSettings(
                                  generalSettings,
                                  "siteName"
                                )}
                              </h3>
                              <h3 className="text-center mt-0">
                                Order Tracking Report
                              </h3>
                              <p className="text-center">
                                FROM&nbsp;
                                <Moment format="LL">
                                  {date.fromDate ? date.fromDate : new Date()}
                                </Moment>
                                &nbsp;TO&nbsp;
                                <Moment format="LL">
                                  {date.toDate ? date.toDate : new Date()}
                                </Moment>
                              </p>
                            </div>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th>S/L</th>
                        <th>Branch Name</th>
                        <th>Total Order</th>
                        <th>Processing</th>
                        <th>Complete On Time</th>
                        <th>Complete Late</th>
                        <th>Pick Up Time</th>
                        <th>Pick Up Late</th>
                      </tr>
                    </thead>
                    <tbody className="align-middle">
                      {/* loop here*/}
                      {Array.isArray(detail) &&
                        detail.map((order, index) => {
                          return (
                            <>
                              {order.details?.length > 0 &&
                                order.details.map(
                                  (orderDetail, ind) => {
                                    return (
                                      <tr key={ind}>
                                        <td>{ind + 1}</td>
                                        <td>
                                          {orderDetail.branch_name}
                                        </td>
                                        <td>
                                          <strong>{orderDetail.total_orders}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.processing}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.complete_on_time}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.complete_late}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.pickup_on_time}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.pickup_late}</strong>
                                        </td>
                                        <td>
                                          <strong>{orderDetail.delivery_time}</strong>
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                              <tr key={index}>
                                <th>
                                  {/* {order.branch_name} */}
                                </th>
                                <th>Total</th>
                                <td> <strong>{order.total_orders}</strong></td>
                                <td> <strong>{order.processing}</strong></td>
                                <td> <strong>{order.complete_on_time}</strong></td>
                                <td> <strong>{order.complete_late}</strong></td>
                                <td> <strong>{order.pickup_on_time}</strong></td>
                                <td> <strong>{order.pickup_late}</strong></td>
                              </tr>
                              <tr></tr>  
                            </>
                          );
                        })}
                    </tbody>
                    <tfoot style={{ border: "0px" }}>
                      <tr style={{ border: "0px" }}>
                        <td
                          colspan="8"
                          className="text-center"
                          style={{ border: "0px" }}
                        >
                          <h5 className="mt-3">Powered by indolj.pk</h5>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </>
          )}
        </div>
      </div>

      <div className={`col ${size} row mx-0 mt-3 px-1`}>
        {heading ? (
          <div className="d-flex align-items-center justify-content-between mb-1">
            <h4 className="mb-1">{heading}</h4>
            <button
              className="btn btn-primary rounded-sm table-text"
              onClick={() => handleReportDownload()}
            >
              Download Report
            </button>
          </div>
        ) : (
          ""
        )}
        <div className="row mx-0 px-0 flex-wrap dashboard__card-container">
          {Object.keys(cards)?.length && Object.keys(cards).map((key, index) => {
            const value = cards[key];
            return (
            <div key={index} className="col-2 p-1">
              <div
                className="col p-0 flex-nowrap dashboard__card_view p-2"
                style={{ margin: "0 0.4rem" }}
              >
                <div className="col m-0 p-0">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-capitalize font-weight-md table-text mb-0">
                      {formatKey(key)}
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="d-block">
                      <p className="font-weight-bold xslg-text mb-0">
                        {value?.toLocaleString()}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )})}
        </div>
      </div>
    </>
  );
};

export default OrderCardsWidget;
